export default {"src":"/_next/static/media/payment-amex.c6f075d8.svg","height":30,"width":44,"blurWidth":0,"blurHeight":0};